import routerOptions0 from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPI-JOB1/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}